import React from "react";
import styled from "styled-components";

export default function AppHeader() {
  return (
    <StyledHeader>
      <div className="inner">
        <h1>Simple ToDo</h1>
      </div>
    </StyledHeader>
  );
}

const StyledHeader = styled.header`
  background-color: #f5f5f5;
  .inner {
    display: flex;
    align-items: center;
    padding: 40px 20px;
  }
  h1 {
    margin: 0;
  }
`;
